import {useMutation} from '@tanstack/react-query';
import campaignUpdaters from '@/api/updaters/campaign';
import invalidateCampaignInvitedQueries from '@/views/campaigns/creators-tab/utils/invalidateCampaignInvitedQueries';

type UseInviteCreatorToCampaignArgs = {
  onSuccess?: (data: unknown) => void;
  onMutate?: (data: unknown) => void;
  onError?: (error: unknown, variables: unknown, context: unknown) => void;
  onSettled?: (data: unknown, error: unknown) => void;
};

function useInviteCreatorToCampaign(args: UseInviteCreatorToCampaignArgs) {
  const {onSuccess, ...rest} = args;
  return useMutation({
    mutationKey: ['inviteCreatorToCampaign'],
    mutationFn: campaignUpdaters.inviteCreatorToCampaign,
    ...rest,
    onSuccess: (data) => {
      invalidateCampaignInvitedQueries();
      onSuccess?.(data);
    },
  });
}

export default useInviteCreatorToCampaign;
